var React = require('react');

function CloseMenu (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"className":"close-line","fill":"none","stroke":"currentColor","strokeWidth":"2px","strokeLinecap":"square","strokeMiterlimit":"10","d":"m5.054 5.054 22.028 22.028","key":1}),React.createElement("path",{"className":"close-line","id":"line12","fill":"none","stroke":"currentColor","strokeWidth":"2px","strokeLinecap":"square","strokeMiterlimit":"10","d":"M27.082 5.054 5.054 27.082","key":2})]);
}

CloseMenu.defaultProps = {"viewBox":"0 0 32 32"};

module.exports = CloseMenu;

CloseMenu.default = CloseMenu;
